(function () {
  function activarCarrito(contenedor) {
    contenedor.addEventListener('click', function (evento) {
      var boton = evento.target.closest('[data-anadir-carrito]');
      if (!boton || boton.disabled) return;

      var variantId = boton.getAttribute('data-variant-id');
      var etiqueta = boton.querySelector('span');
      var textoOriginal = etiqueta ? etiqueta.textContent : boton.textContent;
      boton.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (respuesta) {
          if (!respuesta.ok) throw new Error('cart add failed');
          return respuesta.json();
        })
        .then(function () {
          if (etiqueta) etiqueta.textContent = 'Añadido';
          boton.classList.add('is-added');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          window.setTimeout(function () {
            if (etiqueta) etiqueta.textContent = textoOriginal;
            boton.classList.remove('is-added');
            boton.disabled = false;
          }, 1800);
        })
        .catch(function () {
          if (etiqueta) etiqueta.textContent = textoOriginal;
          boton.disabled = false;
        });
    });
  }

  function iniciarRelacionados(contenedor) {
    if (contenedor.dataset.iniciado === 'true') return;
    contenedor.dataset.iniciado = 'true';

    var url = contenedor.getAttribute('data-url');
    var productoId = contenedor.getAttribute('data-producto-id');
    var limite = contenedor.getAttribute('data-limite');
    var idSeccion = contenedor.getAttribute('data-section-id');

    if (!url || !productoId || !idSeccion) return;

    var peticion = url + '?section_id=' + idSeccion + '&product_id=' + productoId + '&limit=' + limite + '&intent=related';

    fetch(peticion)
      .then(function (respuesta) {
        if (!respuesta.ok) throw new Error('no se pudieron cargar las recomendaciones');
        return respuesta.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nuevo = doc.querySelector('[data-relacionados]');
        if (!nuevo || !nuevo.innerHTML.trim()) return;
        contenedor.innerHTML = nuevo.innerHTML;
        activarCarrito(contenedor);
      })
      .catch(function () {});
  }

  function iniciarTodo() {
    document.querySelectorAll('[data-relacionados]').forEach(iniciarRelacionados);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodo);
  } else {
    iniciarTodo();
  }

  document.addEventListener('shopify:section:load', iniciarTodo);
})();